import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { useLocation } from "react-router-dom";
import Table from "../../Components/TransactionCashUpi/Table";
import PropertiesFilterDropdown from "../../Components/PropertyFilterDropdown";

const Transaction = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const location = useLocation();
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [option ,setOption] = useState("phone");
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(1, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const { t } = useTranslation();

  const initialValues = {
    name: "",
    propertyName: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(1, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
    option: "phone"
  };

  const fetchFunction = async () => {
    const body = new FormData();

    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("filterType", option);
    body.append("filterValue", filterValue);
    if (selectedProperty?.id) {
      body.append("propertyId", selectedProperty.id);
    }
    return await axios.post(`${Config.apiUrl}/transactions`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const {
    isLoading,
    mutate: getTransactionMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {});

  useEffect(() => {
    const handler = setTimeout(() => {
      getTransactionMutate();
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate, selectedProperty]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getTransactionMutate();
  };

  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Transactions")}
                <span>{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
          </div>
          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              option={option}
              setOption={setOption}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              selectedProperty={selectedProperty}
              setSelectedProperty={setSelectedProperty}
              t={t}
            />
          </div>

          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={error ? [] : data?.data?.data}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                userType={user.userType}
              />
              {(error || data?.data?.msg === "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};
const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  filter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  t,
  option,
  setOption,
  setSelectedProperty,
  selectedProperty
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[130px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    class="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    class="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>
          <div className="flex gap-4 items-end">
            {filter !== "status" ? (
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="filterVal">{("")}</Label>
                <Field
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  class="ml-1"
                  value={filterValue}
                  onChange={ChangeHandler}
                  className="border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2"
                />
              </InputGroup>
            ) : filter === "status" ? (
              <InputGroup
                className="min-w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select")}</Label>
                <Select
                  autoComplete="off"
                  className="px-2 bg-transparent text-sm border-none"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                >
                  <MenuItem value="1">{t("PENDING")}</MenuItem>
                  <MenuItem value="2">{t("SUCCESS")}</MenuItem>
                  <MenuItem value="3">{t("FAILED")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null}
           <InputGroup
              className="min-w-[120px]"
              
              style={{ flexBasis: "content" }}
            >
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                id="option"
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={option}
                onChange={(e) => {
                  // set
                  // console.log("filter inside values is :", option);
                  setOption(e.target.value);
                  // setFilterValue("");
                }}
              >
                <MenuItem value="phone">Phone</MenuItem>
                <MenuItem value="name">Name </MenuItem>
              </Select>
            </InputGroup>

            
          </div>
        </FilterContainer>
        <div className="w-full mt-4">
          <div className="max-w-[300px]">
            <PropertiesFilterDropdown
              placeholder="Select Property"
              className="w-full"
              selectedProperty={selectedProperty}
              onPropertySelect={(prop) => setSelectedProperty(prop)}

            />
          </div>
        </div>
      </Form>
    </Formik>
  );
};
const TableWrapper = tw.h1`my-10 border  bg-white rounded-md`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
export default Transaction;